import { render } from "./Play.vue?vue&type=template&id=fb0c7a90"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__